export const getFilterDataForValidateUserQuery = (
  userName: string
) => {
  return `
    query ValidateUser {
      ValidateUser(input: {
        username: "${userName}"
      }) {
        responseStatus {
          status
          statusReason
          errorCode
          reasons
          errorMessages
          internalErrorCode
        }
        username
        name
        actorDetails{
        actorId
        actorName
        actorType
        }
        countryName
      }
    }
  `;
};
